import { useEffect } from "react";
import { useLocationStore } from "@/store/userPosition";
import { useUserDataContext } from "@/store/UserProvider";
import { trackMetadata } from "@/api/analytics";
import { useTariffLayer } from "@/store/mode";

export default function UserMetadataPoller(): null {
  const { user } = useUserDataContext();
  const requestLocationOnce = useLocationStore((s) => s.requestLocationOnce);
  const tariffLayer = useTariffLayer((s) => s.tariffLayer);

  useEffect(() => {
    const tick = async () => {
      const loc = await requestLocationOnce(false);
      if (!user) return;
      try {
        await trackMetadata({
          lat: loc?.latitude,
          lon: loc?.longitude,
          selected_tariff: tariffLayer,
        });
      } catch (e) {
        //
      }
    };

    tick();
    const id = setInterval(tick, 5000);

    return () => {
      clearInterval(id);
    };
  }, [user, tariffLayer]);

  return null;
}
